var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6 2.6C9.6 3.19223 9.27824 3.7093 8.8 3.98595V5H13.2C14.3046 5 15.2 5.89543 15.2 7L15.2 8.2C15.6418 8.2 16 8.55817 16 9V10.6C16 11.0418 15.6418 11.4 15.2 11.4L15.2 13.4C15.2 14.5046 14.3046 15.4 13.2 15.4H2.8C1.69543 15.4 0.8 14.5046 0.8 13.4V11.4C0.358172 11.4 0 11.0418 0 10.6V9C0 8.55817 0.358172 8.2 0.8 8.2V7C0.8 5.89543 1.69543 5 2.8 5H7.2V3.98595C6.72176 3.7093 6.4 3.19223 6.4 2.6C6.4 1.71634 7.11634 1 8 1C8.88366 1 9.6 1.71634 9.6 2.6ZM5.2 9.8C5.86274 9.8 6.4 9.26274 6.4 8.6C6.4 7.93726 5.86274 7.4 5.2 7.4C4.53726 7.4 4 7.93726 4 8.6C4 9.26274 4.53726 9.8 5.2 9.8ZM12 8.6C12 9.26274 11.4627 9.8 10.8 9.8C10.1373 9.8 9.6 9.26274 9.6 8.6C9.6 7.93726 10.1373 7.4 10.8 7.4C11.4627 7.4 12 7.93726 12 8.6ZM9.6 13C10.4837 13 11.2 12.2837 11.2 11.4H4.8C4.8 12.2837 5.51635 13 6.4 13H9.6Z",
    fill: "#0688FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBot);
export default __webpack_public_path__ + "static/media/icon-bot.e06c966edbb554a80dc4485ecd279b8b.svg";
export { ForwardRef as ReactComponent };